import { FaBrain, FaCode, FaLock, FaCloud, FaBolt, FaUsers } from 'react-icons/fa';

const whyChooseUs = {
    sub: "Why Choose Us",
    heading: "Empower with Innovation",
    content: "We are a dynamic startup focused on delivering intelligent IT and AI solutions that empower businesses to scale and succeed.",
    points: [
        {
            id: 1,
            icon: <FaBrain />, // AI Innovation icon
            title: 'AI Innovation',
            content: 'Drive & transform with AI tailored to your business needs.',
        },
        {
            id: 2,
            icon: <FaCode />, // Code Development icon
            title: 'Code Development',
            content: 'Build scalable applications designed to solve your challenges.',
        },
        {
            id: 3,
            icon: <FaLock />, // Cybersecurity icon
            title: 'Digital Security',
            content: 'Safeguard your data with state-of-art cybersecurity solutions.',
        },
        {
            id: 4,
            icon: <FaCloud />, // Cloud Integration icon
            title: 'Cloud Integration',
            content: 'Leverage the power of cloud computing for scalability.',
        },
        {
            id: 5,
            icon: <FaBolt />, // High-Performance icon
            title: 'High-Performance',
            content: 'Experience advanced technology optimized for speed.',
        },
        {
            id: 6,
            icon: <FaUsers />, // Expert Team icon
            title: 'Expert Team',
            content: 'Work with an experienced and professional team.',
        },
    ]
}

export default whyChooseUs;